export const FONT_FAMILY = 'Open Sans';
